// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"dc90d522","396":"4aa18a0b","863":"e8b63c2a","873":"3c0cf460","892":"777d10c0","952":"eb260202"}[chunkId] + ".chunk.js";
};